import $ from 'jquery'
import setNav from 'modules/setnav';

var worksMenuToggle = function() {
  console.log("works-menu-loaded")
  $('.js-works-trigger').click(function(){
    if ($('body').hasClass('js-works-open')){
      $('body').removeClass('js-works-open');
      $('.main-menu .js-works-trigger').removeClass('active');
      setNav();
      console.log("close")
    }
    else{
      $('body').addClass('js-works-open');
      $('.active').removeClass('active');
      $('.main-menu .js-works-trigger').addClass('active');
      console.log("open")
    }
  });
}

export default worksMenuToggle;



// WEBPACK FOOTER //
// ./source/scripts/modules/worksmenu.js